// Reducer extracted from LoginModule.js

import _ from "lodash";
import update from "immutability-helper";
import { isDemoDayBannerVisiblityEnabled } from "Utils/ACLStoreUtils";
import {
  AUTH_SUPERADMIN_SUCCESS,
  REMOVE_SUPERADMIN_AUTH,
  SET_DESIGNATION_LIST,
  AUTH_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  SET_LOADING_STATE,
  SET_GLOBAL_TRAY_ENABLED_STATE,
  SET_GLOBAL_TRAY_RETRACTED_STATE,
  ADD_ICON_TO_HIDDEN_GLOBAL_TRAY_ICONS,
  REMOVE_ICON_FROM_HIDDEN_GLOBAL_TRAY_ICONS,
  SET_GLOBAL_TRAY_UNREAD_COUNT,
  SET_TOAST_MSG,
  CLEAR_TOAST_MSG,
  SET_ACTIVE_TAB,
  SET_CURRENT_PAGE_TITLE,
  UPDATE_INPUT_FIELD,
  SET_CURRENT_SCREEN,
  SET_LOGIN_ERROR,
  SET_HELP_CENTER_VIDEO_DIRECT_LINK,
  RETENTION_MODAL_STATUS,
  BIFURCATION_MODAL_STATUS,
  UPDATE_ORGANIZATION_FILTERS,
  INIT_ORGANIZATION_FILTERS,
  UPDATE_ORGANIZATION_LIST_DATA,
  SET_BIFURCATION_ACTION,
  SET_REDIRECT_URL,
  SET_IS_USER_FROM_PUBLIC_ACCESS,
  SET_CHILD_STATUS,
  SET_PRODUCT_UPDATE_DIRECT_LINK,
  SET_PRODUCT_UPDATE_MODAL_OPEN,
  SET_PRODUCT_UPDATE_MODAL_VISIBLE,
  SET_LAST_CHILD_STATUS,
  SET_CHILD_DATA,
  SET_IS_UNMAPPED_PARENT,
  SET_PARENT_LOGIN_TAB,
  SET_AUTH_REGION,
  SET_PARENT_INVITE_CODE,
  UPDATE_USER_INFO,
  UPDATE_INVITED_FAMILY_DATA,
  UPDATE_INVITED_FAMILY_CHILD_DATA,
  UPDATE_ORGANIZATION_SWITCHER_DETAILS,
  SET_IDENTITY_POOL_DETAILS,
  SET_USER_IDENTITY_DETAILS,
  SET_IDENTITY_SCREEN_FILTERS,
  SET_PORTAL_TYPE,
  SET_SELECTED_ICON,
  SET_MESSAGING_USER_ID,
  SET_MESSAGING_CHAT_ID,
  SET_UNDER_MAINTENANCE,
  TOGGLE_IS_SPRINKLR_CHAT_OPEN,
  UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT,
  SET_IS_USER_CONFIGURATIONS_FETCHED,
  SET_USER_COURSES_IDS,
  SET_IDP_LIST,
  SET_PUBLIC_TOKEN,
  ADD_BANNER,
  REMOVE_BANNER,
  SET_GLOBAL_HEADER_VISIBILITY,
  SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE,
  SET_DEMO_DAY_BANNER_VISIBILITY,
  UPDATE_SESSION_VERIFICATION_DETAILS,
  SET_SHORTCUT_TOAST_VISIBILITY,
  SET_ORG_WORKSPACE_DETAILS,
  CLEAR_ORG_WORKSPACE_DETAILS,
  SET_CHILD_ID,
  SENTRAL_PORTAL_DETAILS,
  SET_SSO_REQUEST_INITIATED_FAILED,
  SET_SAML_INITIATED_DETAILS,
  UPDATE_MFA_VERIFICATION_DETAILS,
  SETUP_MFA_VERIFICATION_DETAILS,
} from "./LoginConstants";

// Reducer
export default function myReducer(state, action) {
  const initialState = {
    organizationFilters: {
      searchText: "",
    },
    activeTab: null,
    tags: [],
    currentScreen: "loginHome",
    formData: {
      loginForm: {
        email: "",
        password: "",
      },
      requestSuccess: {
        firstName: "Gautam",
        isDomainValid: true,
        status: "REQ_ACC_NO_ORG",
      },
      studentLogin: {
        code: "",
      },
      samlLoginForm: {
        schoolcode: "",
      },
      schoolCodeForm: {
        schoolcode: "",
      },
      loginFormV3: {
        email: "",
        phoneNo: "",
        otp: "",
        password: "",
        shouldShowOTPField: false,
        shouldShowPasswordField: false,
        shouldRenderPhoneInput: false,
        shouldShowChangeEmailOption: false,
        resendTimer: 0,
        shouldSkipResetPasswordScreen: true,
      },
    },
    userInfo: {
      id: "",
      user_type: "",
      userEntityType: "STAFF",
      first_name: "",
      middle_name: "",
      last_name: "",
      preferred_name: "",
      prefix: "",
      suffix: "",
      pronouns: "",
      gender: "F",
      is_admin: false,
      email: "",
      profile_image: "",

      grades: [],
      userDetailsHash: [],
      // isAdmin: false,
    },

    toast: {
      msg: "",
      type: "warning",
      position: "toast-bottom-left",
      showToast: false,
      isClosable: false,
      timeOut: 2000,
    },
    lastLoginUserType: "student",
    //roles:[],
    permissionGroups: ["Dashboards", "ToolPortal", "Common"],
    userLoggedIn: false,
    isLoading: true,
    designationList: [],
    sa: {
      loggedIn: false,
      token: null,
      orgList: [],
    },
    organizationListData: {},
    retentionModalStatus: false,
    bifurcationModalStatus: false,
    organizationSwitcherDetails: {
      isVisible: false,
      userEntityType: "",
      userId: "",
    },
    bifurcationAction: null,
    redirectUrl: null,
    isChildPresent: false,
    invitedFamilyData: {},
    invitedFamilyChildData: {},
    identityPoolDetails: null,
    identityScreenFilters: {},
    authRegion: null,
    currentPageTitle: {},
    portalType: null,
    parentInviteCode: null,
    userIdentityDetails: [],
    // selectedIcon used in Global message tray to decide which icon to highlight
    selectedIcon: "",
    // Used in global tray. When a user messaging option is clicked from anywhere in platform
    // it should open global tray and pass the userId and open its conversation
    messagingUser: {
      id: null,
    },
    // Used to maintain state in messaging widget
    // When the user clicks on a messaging icon from global tray,
    // it should open the previously opened conversation if it exists
    messagingChatId: null,
    underMaintenance: {},
    isSprinklrChatOpen: false,
    sprinklrUnreadMessageCount: 0,
    isUserConfigurationsFetched: false,
    isGlobalTrayEnabled: true,
    hiddenGlobalTrayIcons: [],
    isGlobalTrayRetracted: true,
    totalUnreadTrayCount: 0,
    userCoursesIds: [],
    publicToken: null,
    isUnmappedParent: false,
    banners: [],
    globalHeader: {
      isVisible: false,
      isValidRoute: false,
    },
    isDemoDayBannerVisible: isDemoDayBannerVisiblityEnabled(),
    sessionVerificationDetails: {
      isVisible: false,
      otp: "",
      action: "",
      RESEND_TIMER: 0,
    },
    showShortcutToast: false,
    orgWorkspaceDetails: {
      organizationId: null,
      logoUrl: null,
      mainBannerImageUrl: null,
      schoolCode: "",
      loginMethods: [],
    },
    childID: "",
    isProductUpdateModalVisible: false,
    sentralPortalDetails: {
      url: "",
      isVisible: false,
      loader: false,
      platformName: "",
      studentId: "",
      verificationFailed: false,
    },
    ssoRequestInitiatedFailed: false,
    samlInitiatedDetails: {
      relayState: "",
      idpIdentificationId: "",
      samlResponse: "",
      requestInfo: "",
      isInitiated: false,
      openInNewTab: false,
    },
    mfaVerificationDetails: {
      isVisible: false,
      mfaToken: "",
      userType: "",
      userId: "",
      organization: {},
      identityId: "",
      designation: {},
      emailSource: "",
      isUserLoggedIn: false,
      mfaEnabledMethods: [],
      loader: false,
    },
    setupMfaVerificationDetails: {
      isVisible: false,
      userType: "",
      setupKey: "",
      totpAuthUri: "",
      method: "",
    },
  };

  const REDUCER_HANDLERS = {
    [AUTH_SUPERADMIN_SUCCESS]: (state, action) => {
      const data = action.payload;
      return update(state, {
        sa: {
          loggedIn: { $set: true },
          token: { $set: data.token },
          orgList: { $set: data.org_list },
        },
      });
    },
    [REMOVE_SUPERADMIN_AUTH]: (state, action) => {
      return update(state, {
        sa: {
          loggedIn: { $set: false },
          token: { $set: null },
          orgList: { $set: [] },
        },
      });
    },
    [AUTH_USER_SUCCESS]: (state, action) => {
      const inData = action.payload;
      Object.keys(inData).map((key, index) => {
        const data = inData[key];

        state = update(state, {
          userLoggedIn: { $set: _.get(inData, "userLoggedIn", false) },
        });
      });
      return state;
    },
    [LOGOUT_USER_SUCCESS]: (state, action) => {
      state = update(state, {
        userInfo: { $set: initialState.userInfo },
        userIdentityDetails: { $set: initialState.userIdentityDetails },
        userLoggedIn: { $set: false },
      });
      return state;
    },
    [SET_LOADING_STATE]: (state, action) => {
      return update(state, { isLoading: { $set: action.payload } });
    },
    [SET_GLOBAL_TRAY_ENABLED_STATE]: (state, action) => {
      return update(state, {
        isGlobalTrayEnabled: { $set: action.payload },
      });
    },
    [SET_GLOBAL_TRAY_RETRACTED_STATE]: (state, action) => {
      return update(state, {
        isGlobalTrayRetracted: { $set: action.payload },
      });
    },
    [SET_GLOBAL_TRAY_UNREAD_COUNT]: (state, action) => {
      return update(state, {
        totalUnreadTrayCount: { $set: action.payload },
      });
    },
    [ADD_ICON_TO_HIDDEN_GLOBAL_TRAY_ICONS]: (state, action) => {
      return update(state, {
        hiddenGlobalTrayIcons: hiddenGlobalTrayIcons => [
          ...hiddenGlobalTrayIcons,
          action.payload,
        ],
      });
    },
    [REMOVE_ICON_FROM_HIDDEN_GLOBAL_TRAY_ICONS]: (state, action) => {
      return update(state, {
        hiddenGlobalTrayIcons: hiddenGlobalTrayIcons =>
          _.filter(hiddenGlobalTrayIcons, icon => icon !== action.payload),
      });
    },
    [SET_TOAST_MSG]: (state, action) => {
      state = update(state, {
        toast: { $set: initialState.toast },
      });
      if (action.payload !== null && typeof action.payload === "object") {
        Object.keys(action.payload).map((key, index) => {
          state = update(state, {
            toast: { [key]: { $set: action.payload[key] } },
          });
        });
      } else {
        state = update(state, {
          toast: { msg: { $set: action.payload } },
        });
      }
      state = update(state, {
        toast: { showToast: { $set: true } },
      });
      return state;
    },
    [SET_ACTIVE_TAB]: (state, action) => {
      //  console.log(action.payload);
      return Object.assign({}, state, { activeTab: action.payload });
    },
    [SET_CURRENT_PAGE_TITLE]: (state, action) => {
      return Object.assign({}, state, { currentPageTitle: action.payload });
    },
    [SET_DESIGNATION_LIST]: (state, action) => {
      return Object.assign({}, state, { designationList: action.payload });
    },
    [CLEAR_TOAST_MSG]: (state, action) => {
      return update(state, { toast: { showToast: { $set: false } } });
    },

    [UPDATE_INPUT_FIELD]: (state, action) => {
      const { screenName, data } = action.payload;

      const keys = Object.keys(data);
      if (!_.get(state.formData, screenName, "") || _.isEmpty(data)) {
        state = update(state, { formData: { [screenName]: { $set: {} } } });
      }
      _.forEach(keys, key => {
        state = update(state, {
          formData: {
            [screenName]: { [key]: { $set: data[key] } },
          },
        });
      });

      return state;
    },
    [SET_CURRENT_SCREEN]: (state, action) => {
      return update(state, { currentScreen: { $set: action.data } });
    },

    [SET_HELP_CENTER_VIDEO_DIRECT_LINK]: (state, action) => {
      return update(state, { helpCenterVideoModalId: { $set: action.data } });
    },

    [RETENTION_MODAL_STATUS]: (state, action) => {
      return update(state, { retentionModalStatus: { $set: action.data } });
    },

    [BIFURCATION_MODAL_STATUS]: (state, action) => {
      return update(state, { bifurcationModalStatus: { $set: action.data } });
    },

    [INIT_ORGANIZATION_FILTERS]: (state, action) => {
      return update(state, {
        organizationFilters: { $set: initialState.organizationFilters },
      });
    },
    [UPDATE_ORGANIZATION_FILTERS]: (state, action) => {
      const { key, value } = action.data;
      return update(state, {
        organizationFilters: { [key]: { $set: value } },
      });
    },
    [UPDATE_ORGANIZATION_LIST_DATA]: (state, action) => {
      const inData = action.payload;
      _.map(Object.keys(inData), key => {
        state = update(state, {
          organizationListData: { [key]: { $set: inData[key] } },
        });
      });
      return state;
    },
    [SET_LOGIN_ERROR]: (state, action) => {
      return update(state, {
        loginError: { $set: action.payload },
      });
    },
    [SET_BIFURCATION_ACTION]: (state, action) => {
      return update(state, { bifurcationAction: { $set: action.payload } });
    },
    [SET_REDIRECT_URL]: (state, action) => {
      return update(state, { redirectUrl: { $set: action.payload } });
    },
    [SET_IS_USER_FROM_PUBLIC_ACCESS]: (state, action) => {
      return update(state, {
        isUserComingFromPublicAccess: { $set: action.payload },
      });
    },
    [SET_LAST_CHILD_STATUS]: (state, action) => {
      return update(state, {
        isLastChildRemoved: { $set: action.payload },
      });
    },
    [SET_CHILD_STATUS]: (state, action) => {
      return update(state, {
        isChildPresent: { $set: action.payload },
      });
    },
    [SET_IS_UNMAPPED_PARENT]: (state, action) => {
      return update(state, {
        isUnmappedParent: { $set: action.payload },
      });
    },
    [SET_PRODUCT_UPDATE_DIRECT_LINK]: (state, action) => {
      return update(state, { productUpdateModalId: { $set: action.payload } });
    },
    [SET_PRODUCT_UPDATE_MODAL_OPEN]: (state, action) => {
      return update(state, {
        shouldProductUpdatesModalOpen: { $set: action.payload },
      });
    },
    [SET_PRODUCT_UPDATE_MODAL_VISIBLE]: (state, action) => {
      return update(state, {
        isProductUpdateModalVisible: { $set: action.payload },
      });
    },
    [SET_CHILD_DATA]: (state, action) => {
      const inData = action.payload;
      Object.keys(inData).map((key, index) => {
        const data = inData[key];

        state = update(state, {});
      });
      return state;
    },
    [SET_PARENT_LOGIN_TAB]: (state, action) => {
      return update(state, {
        currentParentLoginTab: { $set: action.payload },
      });
    },
    [SET_AUTH_REGION]: (state, action) => {
      return update(state, {
        authRegion: { $set: action.payload },
      });
    },
    [SET_PARENT_INVITE_CODE]: (state, action) => {
      return update(state, {
        parentInviteCode: { $set: action.payload },
      });
    },
    [UPDATE_USER_INFO]: (state, action) => {
      const data = action.payload;
      Object.keys(data).map((key, index) => {
        state = update(state, {
          userInfo: { [key]: { $set: data[key] } },
        });
      });
      return state;
    },
    [UPDATE_ORGANIZATION_SWITCHER_DETAILS]: (state, action) => {
      const data = action.payload;
      return update(state, {
        organizationSwitcherDetails: { $set: data },
      });
    },
    [UPDATE_INVITED_FAMILY_DATA]: (state, action) => {
      return update(state, {
        invitedFamilyData: { $set: action.payload },
      });
    },
    [UPDATE_INVITED_FAMILY_CHILD_DATA]: (state, action) => {
      return update(state, {
        invitedFamilyChildData: { $set: action.payload },
      });
    },
    [SET_IDENTITY_POOL_DETAILS]: (state, action) => {
      return update(state, {
        identityPoolDetails: { $set: action.payload },
      });
    },
    [SET_USER_IDENTITY_DETAILS]: (state, action) => {
      return update(state, {
        userIdentityDetails: { $set: action.payload },
      });
    },
    [SET_IDENTITY_SCREEN_FILTERS]: (state, action) => {
      const { payload } = action;

      const keys = _.keys(payload);

      const { identityScreenFilters } = state;

      const updatedIdentityScreenFilters = _.isEmpty(payload)
        ? {}
        : _.reduce(
            keys,
            (result, key) => {
              const filterValue = payload[key];

              return { ...result, [key]: filterValue };
            },
            identityScreenFilters
          );

      return update(state, {
        identityScreenFilters: { $set: updatedIdentityScreenFilters },
      });
    },
    [SET_PORTAL_TYPE]: (state, action) => {
      return update(state, {
        portalType: { $set: action.payload },
      });
    },
    [SET_SELECTED_ICON]: (state, action) => {
      return update(state, {
        selectedIcon: { $set: action.payload },
      });
    },
    [SET_MESSAGING_USER_ID]: (state, action) => {
      return update(state, {
        messagingUser: { $set: action.payload },
      });
    },
    [SET_MESSAGING_CHAT_ID]: (state, action) => {
      return update(state, {
        messagingChatId: { $set: action.payload },
      });
    },
    [SET_UNDER_MAINTENANCE]: (state, action) => {
      return update(state, {
        underMaintenance: { $set: action.payload },
      });
    },
    [TOGGLE_IS_SPRINKLR_CHAT_OPEN]: (state, action) => {
      return update(state, { isSprinklrChatOpen: { $set: action.data } });
    },
    [UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT]: (state, action) => {
      return update(state, {
        sprinklrUnreadMessageCount: { $set: action.data },
      });
    },
    [SET_IS_USER_CONFIGURATIONS_FETCHED]: (state, action) => {
      return update(state, {
        isUserConfigurationsFetched: { $set: action.data },
      });
    },

    [SET_USER_COURSES_IDS]: (state, action) => {
      return update(state, {
        userCoursesIds: { $set: _.map(action.payload, node => node.id) },
      });
    },
    [SET_IDP_LIST]: (state, action) => {
      return update(state, {
        currentIdpsList: { $set: action.payload },
      });
    },

    [SET_PUBLIC_TOKEN]: (state, action) => {
      return update(state, {
        publicToken: { $set: action.payload },
      });
    },
    [ADD_BANNER]: (state, action) => {
      return update(state, {
        banners: banners => _.uniq([...banners, action.payload]),
      });
    },
    [REMOVE_BANNER]: (state, action) => {
      return update(state, {
        banners: banners =>
          _.filter(banners, banner => banner !== action.payload),
      });
    },
    [SET_GLOBAL_HEADER_VISIBILITY]: (state, action) => {
      return update(state, {
        globalHeader: { isVisible: { $set: action.payload } },
      });
    },
    [SET_DEMO_DAY_BANNER_VISIBILITY]: (state, action) => {
      return update(state, {
        isDemoDayBannerVisible: { $set: action.payload },
      });
    },
    [SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE]: (state, action) => {
      return update(state, {
        globalHeader: {
          isVisible: { $set: action.payload },
          isValidRoute: { $set: action.payload },
        },
      });
    },
    [UPDATE_SESSION_VERIFICATION_DETAILS]: (state, action) => {
      const params = action.payload;
      _.map(_.keys(params), (key, index) => {
        state = update(state, {
          sessionVerificationDetails: { [key]: { $set: params[key] } },
        });
      });
      return state;
    },
    [SET_SHORTCUT_TOAST_VISIBILITY]: (state, action) => {
      return update(state, {
        showShortcutToast: { $set: action.payload },
      });
    },
    [SET_ORG_WORKSPACE_DETAILS]: (state, action) => {
      const params = action.payload;
      _.map(_.keys(params), (key, index) => {
        state = update(state, {
          orgWorkspaceDetails: { [key]: { $set: params[key] } },
        });
      });
      return state;
    },
    [CLEAR_ORG_WORKSPACE_DETAILS]: (state, action) => {
      return update(state, {
        orgWorkspaceDetails: { $set: initialState.orgWorkspaceDetails },
      });
    },
    [SET_CHILD_ID]: (state, action) => {
      return update(state, {
        childID: { $set: action.payload },
      });
    },
    [SENTRAL_PORTAL_DETAILS]: (state, action) => {
      const params = action.payload;
      _.map(_.keys(params), key => {
        state = update(state, {
          sentralPortalDetails: { [key]: { $set: params[key] } },
        });
      });
      return state;
    },
    [SET_SSO_REQUEST_INITIATED_FAILED]: (state, action) => {
      return update(state, {
        ssoRequestInitiatedFailed: { $set: action.payload },
      });
    },
    [SET_SAML_INITIATED_DETAILS]: (state, action) => {
      return update(state, {
        samlInitiatedDetails: { $set: action.payload },
      });
    },
    [UPDATE_MFA_VERIFICATION_DETAILS]: (state, action) => {
      const params = action.payload;
      _.map(_.keys(params), key => {
        state = update(state, {
          mfaVerificationDetails: { [key]: { $set: params[key] } },
        });
      });
      return state;
    },
    [SETUP_MFA_VERIFICATION_DETAILS]: (state, action) => {
      const params = action.payload;
      _.map(_.keys(params), key => {
        state = update(state, {
          setupMfaVerificationDetails: { [key]: { $set: params[key] } },
        });
      });
      return state;
    },
  };

  state = state ? state : initialState;
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
